export const isEmail = (email: string) =>
    !!email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$/);

export const isValidEnglishDisplayName = (value: string) =>
    !!value.match(/^[A-Za-z0-9./-]+(?: [A-Za-z0-9./-]+)*$/);

export const isValidArabicDisplayName = (value: string) =>
    !!value.match(/^[\u0600-\u06FF0-9./-]+(?: [\u0600-\u06FF0-9./-]+)*$/);